var _a;
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter.js';
import timezone from 'dayjs/plugin/timezone.js';
import utc from 'dayjs/plugin/utc.js';
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isSameOrAfter);
export class DateUtils {
}
_a = DateUtils;
DateUtils.defaultLocale = 'fr-FR';
DateUtils.defaultTimezone = 'Europe/Paris';
DateUtils.format = (date, options) => {
    var _b, _c;
    if (!date)
        return '';
    const locale = (_b = options === null || options === void 0 ? void 0 : options.locale) !== null && _b !== void 0 ? _b : _a.defaultLocale;
    const timeZone = (_c = options === null || options === void 0 ? void 0 : options.timeZone) !== null && _c !== void 0 ? _c : _a.defaultTimezone;
    if (options === null || options === void 0 ? void 0 : options.hours) {
        return new Intl.DateTimeFormat(locale, {
            dateStyle: 'short',
            timeStyle: 'short',
            timeZone,
        }).format(date);
    }
    return new Intl.DateTimeFormat(locale, {
        dateStyle: 'short',
        timeZone,
    }).format(date);
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGF0ZS51dGlscy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy91dGlscy9kYXRlLXV0aWxzL2RhdGUudXRpbHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLE9BQU8sS0FBSyxNQUFNLE9BQU8sQ0FBQTtBQUN6QixPQUFPLGFBQWEsTUFBTSwrQkFBK0IsQ0FBQTtBQUN6RCxPQUFPLFFBQVEsTUFBTSwwQkFBMEIsQ0FBQTtBQUMvQyxPQUFPLEdBQUcsTUFBTSxxQkFBcUIsQ0FBQTtBQUVyQyxLQUFLLENBQUMsTUFBTSxDQUFDLEdBQUcsQ0FBQyxDQUFBO0FBQ2pCLEtBQUssQ0FBQyxNQUFNLENBQUMsUUFBUSxDQUFDLENBQUE7QUFDdEIsS0FBSyxDQUFDLE1BQU0sQ0FBQyxhQUFhLENBQUMsQ0FBQTtBQVEzQixNQUFNLE9BQU8sU0FBUzs7O0FBQ0ksdUJBQWEsR0FBRyxPQUFPLEFBQVYsQ0FBVTtBQUN2Qix5QkFBZSxHQUFHLGNBQWMsQUFBakIsQ0FBaUI7QUFFakQsZ0JBQU0sR0FBRyxDQUFDLElBQVcsRUFBRSxPQUEwQixFQUFVLEVBQUU7O0lBQ2xFLElBQUksQ0FBQyxJQUFJO1FBQUUsT0FBTyxFQUFFLENBQUE7SUFFcEIsTUFBTSxNQUFNLEdBQUcsTUFBQSxPQUFPLGFBQVAsT0FBTyx1QkFBUCxPQUFPLENBQUUsTUFBTSxtQ0FBSSxFQUFJLENBQUMsYUFBYSxDQUFBO0lBQ3BELE1BQU0sUUFBUSxHQUFHLE1BQUEsT0FBTyxhQUFQLE9BQU8sdUJBQVAsT0FBTyxDQUFFLFFBQVEsbUNBQUksRUFBSSxDQUFDLGVBQWUsQ0FBQTtJQUUxRCxJQUFJLE9BQU8sYUFBUCxPQUFPLHVCQUFQLE9BQU8sQ0FBRSxLQUFLLEVBQUUsQ0FBQztRQUNuQixPQUFPLElBQUksSUFBSSxDQUFDLGNBQWMsQ0FBQyxNQUFNLEVBQUU7WUFDckMsU0FBUyxFQUFFLE9BQU87WUFDbEIsU0FBUyxFQUFFLE9BQU87WUFDbEIsUUFBUTtTQUNULENBQUMsQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDLENBQUE7SUFDakIsQ0FBQztJQUVELE9BQU8sSUFBSSxJQUFJLENBQUMsY0FBYyxDQUFDLE1BQU0sRUFBRTtRQUNyQyxTQUFTLEVBQUUsT0FBTztRQUNsQixRQUFRO0tBQ1QsQ0FBQyxDQUFDLE1BQU0sQ0FBQyxJQUFJLENBQUMsQ0FBQTtBQUNqQixDQUFDLEFBbEJZLENBa0JaIn0=